import { debounce } from '@phx-styleguides/core';

import { MENU_STATE_EVENTS, menuState } from './Menu/menu-state';

export class Navigation {
  public el: HTMLElement;

  constructor(navId: string) {
    const el: HTMLElement | null = document.getElementById(navId);

    if (!el) {
      throw new Error('Navigation element not found');
    }

    this.el = el;

    this.init();
  }

  init() {
    menuState.on(MENU_STATE_EVENTS.UPDATE_PATH, this.onPathsUpdate.bind(this));

    const updateHeight = debounce(this.updateHeightProp, 100);
    const resizeObserver = new ResizeObserver(updateHeight);

    resizeObserver.observe(this.el);
  }

  private updateHeightProp(entries: ResizeObserverEntry[]) {
    const [{ borderBoxSize }] = entries;

    const rootElement = document.documentElement;
    rootElement.style.setProperty('--comp-navigation-height', `${borderBoxSize[0].blockSize}px`);
  }

  private onPathsUpdate({ newPaths }: { newPaths: Set<HTMLElement> }) {
    const logoElement = this.el.querySelector('.navigation__logo');
    const backBtnElement = this.el.querySelector('.navigation__back-btn');

    if (!backBtnElement) {
      return;
    }

    if (backBtnElement && newPaths.size > 1) {
      logoElement?.classList.add('is-hidden');
      backBtnElement.classList.add('is-visible');

      backBtnElement.addEventListener('click', this.onBackBtnClick.bind(this), { once: true });
    } else {
      logoElement?.classList.remove('is-hidden');
      backBtnElement.classList.remove('is-visible');

      backBtnElement.removeEventListener('click', this.onBackBtnClick.bind(this));
    }
  }

  private onBackBtnClick(event: Event) {
    event.stopImmediatePropagation();

    const menuPaths = Array.from(menuState.getPaths());

    menuState.setPaths(menuPaths.slice(0, -1));
  }
}
